<template lang="pug">
  .confirm-dialog
    .dialog-title
      h3.bold.text-center.upper {{ modalProps.title }}

    .dialog-text
      p.xs-f-small.max-at-tweak {{ modalProps.text }}

    SubmitButtons(
      :submit-method="submitPrompt"
      :submit-text="modalProps.confirmText"
      :cancel-method="cancelPrompt"
      :cancel-text="modalProps.cancelText"
    )

</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import SubmitButtons from "./SubmitButtons";

  export default {
    name: "ConfirmDialogTemplate",
    components: {
       SubmitButtons
    },

    computed: {
      ...mapState('modal', [
        'modalProps'
      ])
    },

    methods: {
      ...mapActions('modal', [
        'hideModal'
      ]),

      ...mapMutations('modal', [
        'setModalProps'
      ]),

      cancelPrompt() {
        if (this.modalProps.cancel) {
          this.modalProps.cancel();
        }
        this.hideModal();
        this.setModalProps();
      },

      submitPrompt() {
        if (this.modalProps.confirm) {
          this.modalProps.confirm();
        }
        this.hideModal();
        this.setModalProps();
      }
    }

   }
</script>

<style scoped lang="stylus">
  .confirm-dialog
    .dialog-text
      padding 2em 2em 3em

</style>